import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter, routerShape } from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';

import CatalogueSearchBar from '../CatalogueSearchBar';
import NewSearchButton from '../NewSearchButton';
import SearchTypeDropdown from '../SearchTypeDropdown';
import updateSearchQuery from '../../../helpers/search/updateSearchQuery';

import './MobileSearchBox.scss';


const renderSavedSearchLink = () => (
  <a href="/user/saved_searches">
    <FormattedMessage id="saved_searches" />
  </a>
);

const EXCLUDED_SEARCH_TYPES = ['tag', 'userlist', 'user'];

export class MobileSearchBox extends BcReactComponent {
  constructor(props) {
    super(props);

    const { query, searchType } = this.props;

    this.state = {
      expanded: false,
      searchType,
      query
    };

    this.bindAll(
      'handleExpand',
      'handleCollapse',
      'handleSearchTypeSelect',
      'handleSearch',
      'handleQueryChange'
    );
  }

  handleExpand() {
    this.setState({ expanded: true }, () => {
      setTimeout(() => setFocusWithinElement(this._form), 250);
    });
  }

  handleCollapse() {
    this.setState({ expanded: false }, () => setFocusWithinElement(this._newSearchButton));
  }

  handleSearchTypeSelect(searchType) {
    this.setState({ searchType });
  }

  handleQueryChange(query) {
    this.setState({ query });
  }

  handleSearch() {
    const { searchType, query } = this.state;
    const { router, location, locked, activeFilters } = this.props;

    const newQuery = updateSearchQuery({
      currentQuery: location.query,
      activeFilters: locked && activeFilters,
      query,
      searchType,
      pagination_page: undefined
    });

    router.push({ ...location, query: newQuery });

    this.handleCollapse();
  }

  renderNewSearchButton() {
    return (
      <NewSearchButton
        expanded={this.state.expanded}
        handleCollapse={this.handleCollapse}
        handleExpand={this.handleExpand}
        ref={el => (this._newSearchButton = el)} />
    );
  }

  getSearchTypeOptions() {
    return this.props.searchTypes
      .filter(type => EXCLUDED_SEARCH_TYPES.indexOf(type) === -1)
      .toJS();
  }

  renderSearchForm() {
    if (this.state.expanded) {
      return (
        <form ref={el => (this._form = el)} action=".">
          <h2><FormattedMessage id="section_title_search" /></h2>

          <SearchTypeDropdown
            options={this.getSearchTypeOptions()}
            handleSelect={this.handleSearchTypeSelect}
            selected={this.state.searchType} />

          <CatalogueSearchBar
            query={this.state.query}
            locked={this.props.locked}
            handleChange={this.handleQueryChange}
            handleSearch={this.handleSearch} />
        </form>
      );
    }

    return null;
  }

  renderTopControls() {
    return (
      <div className="top-controls">
        {this.renderNewSearchButton()}
        {renderSavedSearchLink()}
      </div>
    );
  }

  render() {
    return (
      <div className="cp-mobile-search-box">
        {this.renderTopControls()}
        <div className={cn('form-wrapper', { expanded: this.state.expanded })}>
          {this.renderSearchForm()}
        </div>
      </div>
    );
  }


}


MobileSearchBox.propTypes = {
  router: routerShape,
  locked: PropTypes.bool,
  query: PropTypes.string,
  searchType: PropTypes.string,
  searchTypes: ImmutablePropTypes.listOf(PropTypes.string),
  activeFilters: ImmutablePropTypes.map
};

export default withRouter(MobileSearchBox);



// WEBPACK FOOTER //
// ./app/components/search/MobileSearchBox/MobileSearchBox.jsx